import {
  CalendarEventGuest,
  CalendarEventReminder,
  CalendarRef,
} from './external-calendar-event-input';

export enum CalendarEventAvailability {
  Busy = 'busy',
  Free = 'free',
}

export type CalendarEventFormFields = {
  title: string;
  description: string;
  allDay: boolean;
  startDate: Date;
  // ms since midnight; null while all-day
  startTime: number | null;
  endDate: Date;
  endTime: number | null;
  // IANA zone; null = the target calendar's own zone (the Time zone row stays collapsed)
  timeZone: string | null;
  rrule: string | null;
  guests: CalendarEventGuest[];
  videoCall: boolean;
  // the user asked to swap this event's existing conference for a Google Meet one. Starts false on every
  // load — a freshly opened event is not replacing anything — and only a deliberate action sets it.
  replaceVideoCall: boolean;
  location: string;
  calendar: CalendarRef | null;
  busy: boolean;
  // null = calendar-default reminders (or untouched on edit) — omitted from the patch
  reminders: CalendarEventReminder[] | null;
};
